import dayjs from 'dayjs';
import BonusTerm from './BonusTerm.js';
import User from './User.js';
import Job from './Job.js';

export default class Bonus {
  constructor(data) {
    this.id = data?.id;
    this.bonusTermId = data?.bonusTermId;
    this.userId = data?.userId;
    this.jobId = data?.jobId;
    this.currentSalary = data?.currentSalary ? Number(data.currentSalary) : null;
    this.finalEvaluation = data?.finalEvaluation ? Number(data.finalEvaluation) : null;
    this.base = data?.amount ? Number(data.base) : 0;
    this.calcAmount = data?.calcAmount ? Number(data.calcAmount) : 0;
    this.amount = data?.amount ? Number(data.amount) : 0;
    this.additionalAmount = data?.additionalAmount ? Number(data.additionalAmount) : 0;
    this.additionalPoint = data?.additionalPoint ? Number(data.additionalPoint) : 0;
    this.formerTotalAmount = data?.formerTotalAmount ? Number(data.formerTotalAmount) : 0;
    this.totalAmount = data?.totalAmount ? Number(data.totalAmount) : 0;
    this.formerComment = data?.formerComment;
    this.comment = data?.comment;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.bonusTerm = data?.bonusTerm ? new BonusTerm(data?.bonusTerm) : null;
    this.user = data?.user ? new User(data?.user) : null;
    this.job = data?.job ? new Job(data?.job) : null;
  }
}
